<template>
  <section class="bloc-player-controlls scroll-step js-scroll-show" :id="content.section_id">
    <div class="bloc-player-controlls__player">
      <!-- <div ref="playerDOMMobile" class="bloc-video__video video-mobile" :data-plyr-provider="content.video_provider" :data-plyr-embed-id="content.video_id_portrait" :data-poster="require(`@/${content.poster_portrait}`)"></div>
      <div ref="playerDOMDesk" class="bloc-video__video video-desk" :data-plyr-provider="content.video_provider" :data-plyr-embed-id="content.video_id_landscape" :data-poster="require(`@/${content.poster_landscape}`)"></div> -->

       <video v-if="portrait && content.video_src_portrait" id="player" class="bloc-player-controlls__video video-portrait" playsinline ref="playerDOMPortrait">
        <source :src="content.internalFile ? require(`@/${content.video_src_portrait}`) : content.video_src_portrait" type="video/mp4" />
      </video>
      <video v-else-if="!portrait && content.video_src_landscape" id="player" class="bloc-player-controlls__video video-landscape" playsinline ref="playerDOMLandscape">
        <source :src="content.internalFile ? require(`@/${content.video_src_landscape}`) : content.video_src_landscape" type="video/mp4" />
      </video>
    </div>
  </section>
</template>

<script>
import Plyr from 'plyr'
import config from '@/config';

export default {
  name: 'PlayerControlls',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      portrait: config.small || this.forcePortrait,
    }
  },
  mounted () {
     this.player = new Plyr((this.portrait ? this.$refs.playerDOMPortrait : this.$refs.playerDOMLandscape), {
      autopause: false,
      muted: false,
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'fullscreen'],
      ratio: this.portrait ? '9:16' : '16:9',
      volume: 1
    })

    this.bind()

    setTimeout(() => {
      this.player.volume = 1
    }, 1000)
  },
  methods : {
    bind () {
      this.player.on('ready', this.started)
    },
    unbind () {
      this.player.off('ready', this.started)
    },
    started () {
      this.player.volume = 1
    }
  },
  beforeUnmount () {
    this.player && this.player.destroy && this.player.destroy()
    this.unbind()
  },
}
</script>

<style lang="scss">
  .bloc-player-controlls {
    width: grid_m(4, 5);
    background: $th-white;
    padding: rem(55) 0;
    overflow: hidden;
    position: relative;
    margin: 0 auto;

    @include media($from: small) {
      width: 100vw;
      padding: rem(125) 0;
    }

    .video-mobile {
      @include media($from: small) {
        display: none;
      }
    }

    .video-desk {
      @include media($until: small) {
        display: none;
      }
    }

    &__player {
      z-index: 1;
      position: relative;

      @include media($from: small) {
        margin: 0 auto;
        width: grid(8, 7);
      }

      .tablet:not(.tablet-portrait) & {
        width: grid(11, 10);
      }

      @include media($until: small) {
        width: 100% !important;
      }
    }

    .plyr {
      --plyr-color-main: #CCAD7B;

      .plyr__control--overlaid {
        width: 65px;
        height: 40px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba($color: #CCAD7B, $alpha: 0.7);
      }

      .plyr__poster {
        background-size: cover;

        @include media($until: small) {
          background-position: 37%;
        }
      }
    }
  }
</style>
